<template>
  <el-dialog
    :visible="visible"
    title="Спасибо!"
    append-to-body
    custom-class="register-request-modal"
    :show-close="false"
    @close="closeHandler"
  >
    <h2 class="register-request-modal__title">Заявка отправлена</h2>
    <p class="register-request-modal__message">
      Теперь вы можете прейти в Личный кабинет или остаться на сайте
    </p>
    <div class="register-request-modal__actions">
      <el-button type="primary" plain @click="$router.push({ name: 'profile' })"
        >В Личный кабинет</el-button
      ><el-button type="primary" plain @click="$router.push('/')">Вернуться на сайт</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RegisterStepTwoModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    closeHandler() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
.register-request-modal {
  width: 480px;

  @include sm-and-down {
    width: 100%;
  }

  &__title {
    font-size: 24px;
    text-align: center;
    letter-spacing: 0.35px;
    color: $deepdark;
    font-weight: normal;
    margin-bottom: 16px;
  }

  &__message {
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    color: $french-gray;
    margin-bottom: 50px;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include sm-and-down {
      flex-direction: column;
    }

    button {
      font-size: 18px;
      width: 100%;

      @include sm-and-down {
        margin-left: 0 !important;
        margin-bottom: 12px;
      }
    }
  }

  .el-dialog {
    &__title {
      text-transform: uppercase;
    }

    &__header {
      padding: 24px 18px 48px;
    }
  }
}
</style>
